import { useState } from 'react';
import { Accordion } from '../Accordion';
import Button from '../Button/Button';
import { ContractStatus } from '../types';

interface Props {
  onFilterChange: (selectedStatuses: ContractStatus[]) => void;
  defaultStatuses: ContractStatus[];
  statusOptions: ContractStatus[];
  t: any;
  isOpen: boolean;
}

const StatusFilter: React.FC<Props> = ({
  onFilterChange,
  defaultStatuses,
  statusOptions,
  t,
  isOpen,
}) => {
  const [selectedStatuses, setSelectedStatuses] =
    useState<ContractStatus[]>(defaultStatuses);

  const handleStatusToggle = (status: ContractStatus) => {
    setSelectedStatuses((prevSelected) =>
      prevSelected.includes(status)
        ? prevSelected.filter((s) => s !== status)
        : [...prevSelected, status],
    );
  };

  const handleReset = () => {
    setSelectedStatuses(defaultStatuses);
    onFilterChange(defaultStatuses);
  };

  const handleConfirm = () => {
    onFilterChange(selectedStatuses);
  };

  return (
    <Accordion isOpen={isOpen}>
      <div className="grid grid-cols-4">
        {statusOptions.map((status) => (
          <div key={status} className="flex items-center space-x-1-0">
            <input
              type="checkbox"
              className="accent-primary-yellow w-2-0 h-2-0 rounded-base mr-0-8"
              checked={selectedStatuses.includes(status)}
              onChange={() => handleStatusToggle(status)}
            />
            <span
              className="text-body1 font-rg cursor-pointer"
              onClick={() => handleStatusToggle(status)}
            >
              {t(`contracts.status.${status.toLowerCase()}`)}
            </span>
          </div>
        ))}
        <div className="flex mt-2-0 space-x-2-0">
          <Button size="small" variant="secondary" onClick={handleReset}>
            {t('contracts.reset')}
          </Button>
          <Button size="small" onClick={handleConfirm}>
            {t('contracts.apply')}
          </Button>
        </div>
      </div>
    </Accordion>
  );
};

export default StatusFilter;
